import React, { useEffect, useState } from 'react';
import ListPublications from '../components/Web/Publications/ListPublications';
import { getPostsPubApi } from '../api/post';
import { Spinner } from 'react-bootstrap';

export default function Publications() {
    const [ posts, setPosts ] =  useState([]);
    const [ reloadPosts, setReloadPosts ] = useState([]);

    useEffect(() => {
        getPostsPubApi().then(response => {
            setPosts(response.posts);
        });

        setReloadPosts(false);
    }, [reloadPosts]);

    if (!posts) {
        return (
            <Spinner animation="border" role="status" ></Spinner>
        );
    }

    return (
        <div>
            <ListPublications 
                posts={posts}
                setReloadPosts={setReloadPosts} 
            />
        </div>
    )
}